import React, { useContext, useState, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Stack,
  Box,
  TextField,
  Typography,
  Button,
  IconButton,
  Tooltip,
  Avatar,
  Dialog,
  InputAdornment,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { useMutation as mutationDeleteImage } from "react-query";
import { useMutation } from "@apollo/client";
import imageCompression from "browser-image-compression";
import LinearProgress from "@mui/material/LinearProgress";
// Icons
import { BiMinusCircle } from "react-icons/bi";
// Src
import "../../Style/dialogstyle.scss";
import EmptyImage from "../../Assets/empty-image.png";
import { AuthContext } from "../../Context/AuthContext";
// import CropImageFile from "../CropImage/CropImageFile";
import CropImageStuBookFile from "../CropImage/CropImageStuBookFile";
import CreateIcon from "../../Assets/create-icon.svg";

import { SelectMaterial, SelectUnit } from "../Include/DynamicSelect";
import {
  CREATE_LIST_MATERIAL,
  UPDATE_LIST_MATERIAL,
} from "../../Schema/ListMaterialUnit";
import { deleteFileAPI } from "../../api/api";


function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}
// LinearProgressWithLabel.propTypes = {
//      value: PropTypes?.number?.isRequired
// }

export default function ListMaterialUnitBySelectMainForm({
  dialogTitle,
  open,
  handleClose,
  setRefetch,
  editData, 
  sectionVal,
  openMainItem, 
}) {
  
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [unitVal, setUnitVal] = useState({ id: "", title: "" });
  const [materialSelected,setMaterialSelected] = useState({ id: "", title: "" , unitSmall: "" });

  // ======================== Create ListMaterialUnit ======================
  const [createListMaterialUnit] = useMutation(CREATE_LIST_MATERIAL, {
    onCompleted: ({ createListMaterialUnit }) => {
      setLoading(false);
      if (createListMaterialUnit?.status) {
        setAlert(true, "success", createListMaterialUnit?.message);
        handleClose();
        setImageFile("");
        setRefetch();
      } else {
        setAlert(true, "error", createListMaterialUnit?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  // ======================== Update ListMaterialUnit ======================
  const [updateListMaterialUnit] = useMutation(UPDATE_LIST_MATERIAL, {
    onCompleted: ({ updateListMaterialUnit }) => {
      setLoading(false);
      if (updateListMaterialUnit?.status) {
        setAlert(true, "success", updateListMaterialUnit?.message);
        handleClose();
        setImageFile("");
        setRefetch();
      } else {
        setAlert(true, "error", updateListMaterialUnit?.message);
      }
    },
    onError: (error) => {
      setLoading(false);
      setAlert(true, "error", error?.message);
    },
  });

  // ========================= upload Image ================================
  const [profileHook, setProfileHook] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [photoURL, setPhotoURL] = useState(null);
  const [openCrop, setOpenCrop] = useState(false);

  const mutationDelete = mutationDeleteImage(deleteFileAPI, {
    onSuccess: (data) => {
      if (data?.data?.status) {
        console.log("Image successfully deleted:", data?.data?.message);
      } else {
        console.log("Error deleting image:", data?.data?.message);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const handleUploadImage = (e) => {
    const imageFile = e.target.files[0];
    if (imageFile) {
      setImageFile(imageFile);
      setPhotoURL(URL.createObjectURL(imageFile));
      setOpenCrop(true);
    }
  };

  const handleCloseForm = () => {
    // If there's an uploaded image but no submission, delete it
    if (imageFile && dialogTitle === "Create") {
      let splitSrc = imageFile.name.split("/")[0]; // Adjust based on your storage structure
      mutationDelete.mutate({
        storage: "school_inventory",
        folder: "inventory_images",
        file: splitSrc,
      });
    }
    handleClose();
    setImageFile("");
  };

  // ======================= Progress ======================================
  const [statusProgress, setStatusProgress] = useState(false);
  const [progress, setProgress] = useState(10);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) =>
        prevProgress >= 100 ? 100 : prevProgress + 10
      );
    }, 500);
    return () => {
      clearInterval(timer);
    };
  }, []);
  // ===================== End progress ====================================

  // ===================== formik ==========================================
  const validationSchema = Yup.object().shape({
    unitId: Yup.string().required("require!"),
    materialId: Yup.string().required("require!"),
    imageSrc: Yup.string(),
    qtyInUnit: Yup.number().required("require!").min(1, "required"),
    costPerUnit: Yup.number().required("require!").min(0, "required"),
    barcode:
      dialogTitle === "Create"
        ? Yup.string()
        : Yup.string().required("require!"),
    remark: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      materialId: materialSelected?.id,
      barcode: "",
      costPerUnit: "",
      imageSrc: "",
      qtyInUnit: "",
      unitId: "",
      remark: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      // console.log("values::updateListMaterialUnit", values, profileHook);
      console.log("values::dialogTitle", dialogTitle);
      setLoading(true);
      if (dialogTitle === "Create") {
        createListMaterialUnit({
          variables: {
            input: {
              ...values,
              imageSrc: profileHook,
            },
          },
        });
      } else {
        updateListMaterialUnit({
          variables: {
            id: editData?._id,
            input: {
              ...values,
              imageSrc: profileHook ? profileHook : editData?.imageSrc,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    getFieldProps,
    resetForm,
    setFieldValue,
    values,
  } = formik;

  console.log("values:::::", values);

  useEffect(() => {
    if (dialogTitle === "Create") {
      resetForm();
      setProfileHook("");
      setUnitVal({ id: "", title: "" });
    } else {
      // console.log("editData", editData);
      // setProfileHook(editData?.imageSrc);
      setFieldValue("remark", editData?.remark);
      setFieldValue("barcode", editData?.barcode);
      setFieldValue("qtyInUnit", editData?.qtyInUnit);
      setFieldValue("costPerUnit", editData?.costPerUnit);
      setUnitVal({
        id: editData?.unitId?._id,
        title: editData?.unitId?.unitEnName,
      });
      setFieldValue("unitId", editData?.unitId?._id);
    }
  }, [open, editData, setProfileHook]);

  useEffect(() => {
    setFieldValue("unitId", unitVal?.id ? unitVal?.id : "");
  }, [unitVal]);

  useEffect(() => {
    setFieldValue("materialId", materialSelected?.id ? materialSelected?.id : "");
  }, [materialSelected?.id]);

  return (
    <Dialog open={open} className="dialog-container" fullWidth maxWidth="sm">
      <DialogTitle sx={{ padding: "10px 15px 10px 20px " }}>
        <Stack direction="row" justifyContent="space-between">
          <Stack direction="column" justifyContent="center">
            <Typography className="dialog-title">
              {dialogTitle === "Create" ? "បង្កើតសម្ភារៈ" : "កែប្រែសម្ភារៈ"}
            </Typography>
          </Stack>
          <Stack direction="column" justifyContent="center">
            <IconButton
              onClick={() => {
                handleCloseForm();
              }}
            >
              <BiMinusCircle className="close-icon" />
            </IconButton>
          </Stack>
        </Stack>
      </DialogTitle>

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>
              
              <Grid item xs={8}>
                <SelectMaterial
                  selectedVal={materialSelected}
                  setSelectedVal={setMaterialSelected}
                  isUse={null}
                  groupId={null}
                  sectionId={sectionVal?.id} 
                />
              </Grid>

              <Grid item xs={4}>
                <Stack direction="column" justifyContent="center" height="100%" width="100%">
                    <Button
                      onClick={ () => {
                        handleCloseForm();
                        openMainItem(); 
                      }}
                      className="btn-create"
                      sx={{ marginTop: "-1px !important"}}
                      startIcon={
                        <img src={CreateIcon} alt="CreateIcon" className="icon-add" />
                      }                     
                    >
                      បង្កើតឈ្មោះទំនិញគោល
                    </Button> 
                </Stack>
              </Grid>

              <Grid item xs={12}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  {/* <h1>{ materialId?.sizeId ? materialId?.materialEnName + " " + materialId?.sizeId?.sizeEnName : materialId?.materialEnName}</h1> */}
                  <h1>{materialSelected?.title}</h1>
                  <Stack>
                    {!openCrop ? (
                      <Box>
                        <Stack direction="row" justifyContent="center">
                          <Tooltip title="click to upload">
                            <Button
                              component="label"
                              className="btn-upload-user"
                            >
                              <TextField
                                type="file"
                                id="image"
                                sx={{ display: "none" }}
                                onChange={handleUploadImage}
                              />
                              {dialogTitle === "Create" ? (
                                <Avatar
                                  className="avater-image"
                                  src={
                                    imageFile
                                      ? URL.createObjectURL(imageFile)
                                      : EmptyImage
                                  }
                                />
                              ) : (
                                <Avatar
                                  className="avater-image"
                                  src={
                                    imageFile
                                      ? URL.createObjectURL(imageFile)
                                      : editData?.imageSrc
                                      ? editData?.imageSrc
                                      : EmptyImage
                                  }
                                />
                              )}
                            </Button>
                          </Tooltip>
                        </Stack>
                      </Box>
                    ) : (
                      <CropImageStuBookFile
                        setProgress={setProgress}
                        setStatusProgress={setStatusProgress}
                        openCrop={openCrop}
                        setOpenCrop={setOpenCrop}
                        photoURL={photoURL}
                        setPhotoURL={setPhotoURL}
                        setImageFile={setImageFile}
                        setProfileHook={setProfileHook}
                        // imageFromBackEnd={imageFromBackEnd}0
                      />
                    )}

                    {statusProgress && progress < 100 ? (
                      <Box sx={{ width: "100%", marginLeft: "20px" }}>
                        <LinearProgressWithLabel value={progress} />
                      </Box>
                    ) : (
                      <Typography
                        className="field-title"
                        sx={{ textAlign: "center", marginTop: "10px" }}
                      >
                        រូបភាព
                      </Typography>
                    )}
                  </Stack>
                </Stack>
              </Grid>

              <Grid item xs={6}>
                <Typography className="field-title">ឯកតា</Typography>
                <SelectUnit
                  selectedVal={unitVal}
                  setSelectedVal={setUnitVal}
                  error={
                    values?.unitId === ""
                      ? Boolean(touched?.unitId && errors?.unitId) ||
                        unitVal === null
                      : false
                  }
                  helperText={
                    values?.unitId === ""
                      ? (touched?.unitId && errors?.unitId) ||
                        (unitVal === null && "require!")
                      : ""
                  }
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className="field-title">Cost Per Unit</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  type="number"
                  size="small"
                  onFocus={(e) => e.target.select()}
                  placeholder="costPerUnit"
                  {...getFieldProps("costPerUnit")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        {" "}
                        $ / {unitVal?.title}
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(touched?.costPerUnit && errors?.costPerUnit)}
                  helperText={touched?.costPerUnit && errors?.costPerUnit}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className="field-title">Qty in unit</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  onFocus={(e) => e.target.select()}
                  type="number"
                  size="small"
                  placeholder="qtyInUnit"
                  {...getFieldProps("qtyInUnit")}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        {" "}
                        {materialSelected?.unitSmall} / {unitVal?.title}
                      </InputAdornment>
                    ),
                  }}
                  error={Boolean(touched?.qtyInUnit && errors?.qtyInUnit)}
                  helperText={touched?.qtyInUnit && errors?.qtyInUnit}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography className="field-title">Barcode</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  rows={3}
                  size="small"
                  placeholder="barcode"
                  {...getFieldProps("barcode")}
                  error={Boolean(touched?.barcode && errors?.barcode)}
                  helperText={touched?.barcode && errors?.barcode}
                />
              </Grid>

              <Grid item xs={12}>
                <Typography className="field-title">Remark</Typography>
                <TextField
                  className="text-field"
                  fullWidth
                  multiline
                  rows={3}
                  size="small"
                  placeholder="remark"
                  {...getFieldProps("remark")}
                />
              </Grid>

              <Grid item xs={12}>
                <Button
                  className="btn-create"
                  disabled={statusProgress && progress < 100 ? true : false}
                  // disabled={loading}
                  fullWidth
                  onClick={handleSubmit}
                >
                  {loading
                    ? "កំពុងដំណើរការ..."
                    : dialogTitle === "Create"
                    ? "បង្កើត"
                    : "កែប្រែ"}
                </Button>
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
